import { AdminConfigPage } from 'pages/admin-config/admin-config';
import { AdminEditExerciseSlotPage } from 'pages/admin-edit-exercise-slot/admin-edit-exercise-slot';
import { AdminEditTextPage } from 'pages/admin-edit-text/admin-edit-text';
import { AdminExerciseListPage } from 'pages/admin-exercise-list/admin-exercise-list';
import { AdminExerciseSlotListPage } from 'pages/admin-exercise-slot-list/admin-exercise-slot-list';
import { AdminImpersonatedUserPage } from 'pages/admin-impersonated-user/admin-impersonated-user';
import { AdminKeygenPage } from 'pages/admin-keygen/admin-keygen';
import { AdminRootPage } from 'pages/admin-root/admin-root';
import { AdminTextListPage } from 'pages/admin-text-list/admin-text-list';
import { AdminUserPermissionsPage } from 'pages/admin-user-permissions/admin-user-permissions';
import { AdminUserSearchPage } from 'pages/admin-user-search/admin-user-search';
import { AdminUserSubscriptionPage } from 'pages/admin-user-subscription/admin-user-subscription';
import { AdvancedTrainingMethodsPage } from 'pages/advanced-training-methods-page/advanced-training-methods-page';
import { NutritionOptionsPage } from 'pages/nutrition-options-page/nutrition-options-page';
import { BarcodeScannerPage } from 'pages/barcode-scanner-page/barcode-scanner-page';
import { LabelScannerPage } from 'pages/label-scanner-page/label-scanner-page';
import { MealPhotoScannerPage } from 'pages/meal-photo-scanner-page/meal-photo-scanner-page';
import { EquipmentScannerPage } from 'pages/equipment-scanner-page/equipment-scanner-page';
import { WorkoutPlanScannerPage } from 'pages/workout-plan-scanner-page/workout-plan-scanner-page';
import { RecipeScannerPage } from 'pages/recipe-scanner-page/recipe-scanner-page';
import { DbRestoreJsonPage } from 'pages/db-restore-json/db-restore-json';
import { DbSnapshotsPage } from 'pages/db-snapshots/db-snapshots';
import { ChangelogPage } from 'pages/changelog/changelog';
import { EditExercisePage } from 'pages/edit-exercise/edit-exercise-page';
import { ViewExercisePage } from 'pages/view-exercise/view-exercise-page';
import { EditFoodPage } from 'pages/edit-food/edit-food';
import { EditIngredientPage } from 'pages/edit-ingredient/edit-ingredient';
import { EditMealPage } from 'pages/edit-meal/edit-meal';
import { EditWeighInPage } from 'pages/edit-weigh-in/edit-weigh-in';
import { EditTrainingGoalPage } from 'pages/edit-training-goal/edit-training-goal-page';
import { UpdatePlanOptionsPage } from 'pages/update-plan-options/update-plan-options';
import { EditWorkoutsPage } from 'pages/edit-workouts/edit-workouts-page';
import { MuscleVolumePage } from 'pages/muscle-volume-page/muscle-volume-page';
import { EquipmentEditPage } from 'pages/equipment/equipment-edit-page';
import { EquipmentSearchPage } from 'pages/equipment/equipment-search-page';
import { ExerciseStatsPage } from 'pages/exercise-stats/exercise-stats';
import { ExerciseConfigurationPage } from 'pages/exercise-configuration/exercise-configuration-page';
import { ExerciseDiffPage } from 'pages/exercise-diff/exercise-diff-page';
import { ExerciseSwitchPage } from 'pages/exercise-switch/exercise-switch';
import { FatalErrorPage } from 'pages/fatal-error/fatal-error';
import { FoodsPage } from 'pages/foods/foods';
import { HelpCardPage } from 'pages/help-card-page/help-card-page';
import { HelpPage } from 'pages/help-page/help-page';
import { HomePage } from 'pages/home/home';
import { IntakeFormPage } from 'pages/intake-form/intake-form';
import { IntroCarouselPage } from 'pages/intro-carousel-page/intro-carousel-page';
import { AwaitingCoachPage } from 'pages/awaiting-coach/awaiting-coach';
import { LoginPage } from 'pages/login/login';
import { MealPlanPage } from 'pages/meal-plan/meal-plan';
import { MealSuggestionsPage } from 'pages/meal-suggestions/meal-suggestions';
import { EditNutritionPlanPage } from 'pages/edit-nutrition-plan/edit-nutrition-plan';
import { NotePage } from 'pages/note-page/note-page';
import { NutritionInfoPage } from 'pages/nutrition-info-page/nutrition-info-page';
import { PurchaseSuccessPage } from 'pages/purchase-success/purchase-success';
import { TaskCalendarPage } from 'pages/task-calendar-page/task-calendar-page';
import { InputCalendarPage } from 'pages/input-calendar-page/input-calendar-page';
import { ChangeWorkoutPage } from 'pages/change-workout-page/change-workout-page';
import { NutritionPage } from 'pages/nutrition/nutrition';
import { ProgramSettingsPage } from 'pages/program-settings-page/program-settings-page';
import { ProgressPage } from 'pages/progress/progress';
import { RedeemCodePage } from 'pages/redeem-code/redeem-code';
import { ReferralHubPage } from 'pages/referral-hub/referral-hub';
import { ReferralInvitePage } from 'pages/referral-invite/referral-invite';
import { CliAuthPage } from 'pages/cli-auth/cli-auth';
import { SendFeedbackPage } from 'pages/send-feedback/send-feedback';
import { SendCoachMessagePage } from 'pages/send-coach-message/send-coach-message';
import { ScheduleTipsPage } from 'pages/schedule/schedule-tips';
import { AppSettingsPage } from 'pages/settings/app-settings-page';
import { NotificationSettingsPage } from 'pages/notification-settings/notification-settings-page';
import { CustomizeHomepagePage } from 'pages/customize-homepage/customize-homepage-page';
import { SettingsPage } from 'pages/settings-page/settings-page';
import { SubscribePage } from 'pages/subscribe/subscribe';
import { TestWorkoutSolverPage } from 'pages/test-workout-solver/test-workout-solver';
import { TestingRootPage } from 'pages/testing/testing-root';
import { TestNavigationRootPage } from 'pages/test-navigation-root/test-navigation-root';
import { TestNavigationChildPage } from 'pages/test-navigation-child/test-navigation-child';
import { TestUiComponentsPage } from 'pages/test-ui-components/test-ui-components';
import { TestUiToastsPage } from 'pages/test-ui-toasts/test-ui-toasts';
import { TestUiNutrientsPage } from 'pages/test-ui-nutrients/test-ui-nutrients';
import { TrainingPage } from 'pages/training/training';
import { TrainingOverviewPage } from 'pages/training-overview/training-overview';
import { UnsubscribePage } from 'pages/unsubscribe/unsubscribe';
import { UserProfilePage } from 'pages/user-profile/user-profile';
import { WorkoutDetailPage } from 'pages/workout-detail/workout-detail';
import { CoachSettingsPage } from 'pages/coach-settings/coach-settings';
import { CoachBillingPage } from 'pages/coach-billing/coach-billing-page';
import { CoachCheckoutPage } from 'pages/coach-checkout/coach-checkout-page';
import { CoachBrandingPage } from 'pages/coach-branding/coach-branding';
import { CoachClientDetailPage } from 'pages/coach-client-detail/coach-client-detail';
import { CoachClaimPage } from 'pages/coach-claim/coach-claim';
import { DeepLinkMetadata, setAllDeepLinks } from './app-page-helpers';
import { WeeklyCheckupPage } from 'pages/weekly-checkup/weekly-checkup-page';

const allDeepLinks: DeepLinkMetadata[] = [
    // All pages below are organized to represent the "sitemap" of navigation hierarchy
    // empty comments enforce indentation in presence of auto-formatters
    //
    // `parent` names the ONE page Back should land on when this page is opened
    // with no real navigation history — a deep link, a pasted URL, a restored
    // session. setAllDeepLinks() walks the chain of parents and builds the
    // `defaultHistory` array the rest of the app reads, so nobody writes that
    // array out by hand any more. See design-docs/navigation.md, "defaultHistory
    // — the fallback back-stack, and which end of it is the bottom".
    //
    // `parent` is the BACK TARGET, not the position in the menu. Where the two
    // differ, the row names its back target and carries the marker comment
    // `sitemap-parent-differs` so the indentation may keep showing where the page
    // sits in the menu — the two admin user pages below are the example.
    //
    // A row with no `parent` has no fallback trail. app-page-parents.test.ts
    // refuses a parent that is not registered, a chain that loops, a
    // hand-written `defaultHistory`, and an indentation that disagrees with the
    // parent a row declares.
    /**/ { component: LoginPage, name: 'LoginPage', title: 'Login', segment: 'login' },
    /**/ { component: FatalErrorPage, name: 'FatalErrorPage', title: 'Fatal Error', segment: 'fatal-error' },
    /**/ { component: SubscribePage, name: 'SubscribePage', title: 'Subscribe', segment: 'subscribe', parent: UserProfilePage, allowAtWelcome: true },
    /**/ { component: UnsubscribePage, name: 'UnsubscribePage', title: 'Unsubscribe', segment: 'unsubscribe', parent: UserProfilePage, allowAtWelcome: true },
    /**/ { component: ChangelogPage, name: 'ChangelogPage', title: "What's new", segment: 'changelog', parent: HomePage, allowAtWelcome: true },
    /**/ { component: HomePage, name: 'HomePage', title: 'Home', segment: 'home' },
    /**/ { component: EditMealPage, name: 'EditMealPage', title: 'Meal', segment: 'meal' }, // defaultHistory for this page handled by patchHistoryAsync()
    /**/ { component: WorkoutDetailPage, name: 'WorkoutDetailPage', title: 'Workout', segment: 'workout' }, // defaultHistory for this page handled by patchHistoryAsync()
    /**/ { component: EquipmentEditPage, name: 'EquipmentEditPage', title: 'Edit Equipment', segment: 'equipment', parent: EquipmentSearchPage, allowAtWelcome: true },
    /**/ { component: EditWeighInPage, name: 'EditWeighInPage', title: 'Weigh-in', segment: 'weigh-in' }, // defaultHistory for this page handled by patchHistoryAsync()
    /**/ { component: TrainingPage, name: 'TrainingPage', title: 'Training', segment: 'training' },
    /**/ { component: EditWorkoutsPage, name: 'EditWorkoutsPage', title: 'Edit Workouts', segment: 'edit-workouts', parent: TrainingPage, allowAtWelcome: true },
    /**/ { component: NutritionPage, name: 'NutritionPage', title: 'Nutrition', segment: 'nutrition' },
    /**/ { component: ProgramSettingsPage, name: 'ProgramSettingsPage', title: 'Program Settings', segment: 'program-settings', parent: SettingsPage },
    /*  */ { component: AdvancedTrainingMethodsPage, name: 'AdvancedTrainingMethodsPage', title: 'Advanced Training Methods', segment: 'advanced-training-methods', parent: ProgramSettingsPage },
    /*  */ { component: NutritionOptionsPage, name: 'NutritionOptionsPage', title: 'Nutrition Options', segment: 'nutrition-options', parent: ProgramSettingsPage },
    /**/ { component: ScheduleTipsPage, name: 'ScheduleTipsPage', title: 'Schedule Tips', segment: 'schedule-tips', parent: HomePage, allowAtWelcome: true },
    /**/ { component: EquipmentSearchPage, name: 'EquipmentSearchPage', title: 'Equipment', segment: 'equipment-search', parent: HomePage, allowAtWelcome: true },
    /**/ { component: FoodsPage, name: 'FoodsPage', title: 'Foods', segment: 'foods', parent: SettingsPage },
    /**/ { component: BarcodeScannerPage, name: 'BarcodeScannerPage', title: 'Scan barcode', segment: 'barcode-scanner', parent: FoodsPage },
    /**/ { component: LabelScannerPage, name: 'LabelScannerPage', title: 'Scan Label', segment: 'label-scanner', parent: FoodsPage },
    /**/ { component: MealPhotoScannerPage, name: 'MealPhotoScannerPage', title: 'Scan Meal', segment: 'meal-photo-scanner', parent: EditMealPage },
    /**/ { component: EquipmentScannerPage, name: 'EquipmentScannerPage', title: 'Scan Equipment', segment: 'equipment-scanner', parent: EquipmentEditPage },
    /**/ { component: WorkoutPlanScannerPage, name: 'WorkoutPlanScannerPage', title: 'Scan Workout', segment: 'workout-plan-scanner', parent: EditWorkoutsPage },
    /**/ { component: RecipeScannerPage, name: 'RecipeScannerPage', title: 'Scan Recipe', segment: 'recipe-scanner', parent: EditFoodPage },
    /**/ { component: MealPlanPage, name: 'MealPlanPage', title: 'Meal Plan', segment: 'meal-plan', parent: SettingsPage },
    /**/ { component: EditFoodPage, name: 'EditFoodPage', title: 'Food', segment: 'food' }, // defaultHistory for this page handled by patchHistoryAsync()
    /**/ {
    component: EditNutritionPlanPage, name: 'EditNutritionPlanPage', title: 'Edit Daily Nutrition Goal', segment: 'edit-nutrition-plan',
    parent: HomePage, allowAtWelcome: true
  },
    /**/ {
    component: EditIngredientPage, name: 'EditIngredientPage', title: 'Edit Ingredient', segment: 'edit-ingredient',
    parent: HomePage
  },
    /**/ { component: ExerciseSwitchPage, name: 'ExerciseSwitchPage', title: 'Exercise Switch', segment: 'exercise-switch', parent: HomePage, allowAtWelcome: true },
    /**/ { component: EditExercisePage, name: 'EditExercisePage', title: 'Edit Exercise', segment: 'edit-exercise', defaultHistory: [], allowAtWelcome: true },
    // ViewExercisePage owns the `exercise` segment, and the edit page above does NOT.
    // Share links built before the two screens were split point at
    // `/exercise:id~<id>:mode~view`; they are out in the world and cannot be recalled, and
    // one segment resolves to exactly one component. Giving `exercise` to the read-only
    // page is what makes those links land on the right screen with no redirect anywhere.
    /**/ { component: ViewExercisePage, name: 'ViewExercisePage', title: 'Exercise', segment: 'exercise', defaultHistory: [], allowAtWelcome: true },
    /**/ { component: ExerciseConfigurationPage, name: 'ExerciseConfigurationPage', title: 'Exercise Configuration', segment: 'exercise-configuration', defaultHistory: [], allowAtWelcome: true },
    /**/ { component: ExerciseDiffPage, name: 'ExerciseDiffPage', title: 'Update Available', segment: 'exercise-diff', defaultHistory: [], allowAtWelcome: true },
    /**/ { component: MuscleVolumePage, name: 'MuscleVolumePage', title: 'Muscle Volume', segment: 'muscle-volume', parent: ProgramSettingsPage, allowAtWelcome: true },
    /**/ { component: EditTrainingGoalPage, name: 'EditTrainingGoalPage', title: 'Edit Training Goal', segment: 'edit-training-goal', parent: HomePage },
    /**/ { component: UpdatePlanOptionsPage, name: 'UpdatePlanOptionsPage', title: 'Update Your Program', segment: 'update-plan-options' },
    /**/ { component: WeeklyCheckupPage, name: 'WeeklyCheckupPage', title: 'Weekly Checkup', segment: 'weekly-checkup', parent: HomePage },
    /**/ {
    component: ExerciseStatsPage,
    name: 'ExerciseStatsPage', title: 'Exercise Stats',
    segment: 'exercise-stats',
    // defaultHistory for this page handled by patchHistoryAsync()
    allowAtWelcome: true,
  },
    /**/ { component: ProgressPage, name: 'ProgressPage', title: 'Progress', segment: 'progress', parent: SettingsPage },

    /* the below are pages that don't originate from any tab (invoked through side-menu only) */
    /**/ { component: AdminRootPage, name: 'AdminRootPage', title: 'Admin Menu', segment: 'admin-root' },
    /*  */ {
    component: AdminTextListPage,
    name: 'AdminTextListPage', title: 'Admin Texts',
    segment: 'admin-text-list',
    parent: AdminRootPage,
  },
    /*    */ {
    component: AdminEditTextPage,
    name: 'AdminEditTextPage', title: 'Admin Text',
    segment: 'admin-text',
    parent: AdminTextListPage,
  },
    /*  */ {
    component: AdminExerciseListPage,
    name: 'AdminExerciseListPage', title: 'Admin Exercise List',
    segment: 'admin-exercise-list',
    parent: AdminRootPage,
  },
    /*  */ {
    component: AdminExerciseSlotListPage,
    name: 'AdminExerciseSlotListPage', title: 'Admin Slot List',
    segment: 'admin-exercise-slot-list',
    parent: AdminRootPage,
  },
    /*    */ {
    component: AdminEditExerciseSlotPage,
    name: 'AdminEditExerciseSlotPage', title: 'Admin Slot',
    segment: 'admin-exercise-slot',
    parent: AdminExerciseSlotListPage,
  },
    // The next two sit under the Admin menu, which is what their indentation shows,
    // but Back takes you to Admin User Search — you reach either one by picking a
    // user there. That is why both carry the marker comment.
    /*  */ { component: AdminUserPermissionsPage, name: 'AdminUserPermissionsPage', title: 'Admin User Permissions', segment: 'admin-user-permissions', parent: AdminUserSearchPage }, // sitemap-parent-differs
    /*  */ { component: AdminUserSubscriptionPage, name: 'AdminUserSubscriptionPage', title: 'Admin User Subscription', segment: 'admin-user-subscription', parent: AdminUserSearchPage }, // sitemap-parent-differs
    /*  */ { component: AdminUserSearchPage, name: 'AdminUserSearchPage', title: 'Admin User Search', segment: 'admin-user-search', parent: AdminRootPage },
    /*  */ { component: AdminKeygenPage, name: 'AdminKeygenPage', title: 'Admin Keys', segment: 'admin-keygen', parent: AdminRootPage },
    /*  */ { component: AdminConfigPage, name: 'AdminConfigPage', title: 'Admin Config', segment: 'admin-config', parent: AdminRootPage },
    /**/ { component: UserProfilePage, name: 'UserProfilePage', title: 'User Profile', segment: 'user-profile', allowAtWelcome: true },
    /**/ { component: SettingsPage, name: 'SettingsPage', title: 'Settings', segment: 'settings', allowAtWelcome: true },
    /**/ { component: AppSettingsPage, name: 'AppSettingsPage', title: 'App Settings', segment: 'app-settings', parent: SettingsPage, allowAtWelcome: true },
    /**/ { component: NotificationSettingsPage, name: 'NotificationSettingsPage', title: 'Notification Settings', segment: 'notification-settings', parent: SettingsPage },
    /**/ { component: DbSnapshotsPage, name: 'DbSnapshotsPage', title: 'DB Snapshots', segment: 'db-snapshots', parent: TestingRootPage },
    /**/ { component: DbRestoreJsonPage, name: 'DbRestoreJsonPage', title: 'Restore DB from JSON', segment: 'db-restore-json', parent: TestingRootPage },
    /**/ { component: CustomizeHomepagePage, name: 'CustomizeHomepagePage', title: 'Customize Homepage', segment: 'customize-homepage', parent: HomePage },
    /**/ { component: RedeemCodePage, name: 'RedeemCodePage', title: 'Redeem Code', segment: 'redeem-code', parent: HomePage, allowAtWelcome: true },
    // #4627 referral programme. The invite page is opened by somebody who is NOT
    // signed in and has never used the app, so registering it here is only half of
    // what makes it reachable: AppComponent.pageFilterAsync names the pages a
    // signed-out visitor may see, and this page had to be added there too.
    // `allowAtWelcome` is a different thing again — it lets a SIGNED-IN user whose
    // plan is still in a welcome phase reach the page instead of being sent back to
    // the welcome screen.
    /**/ { component: ReferralInvitePage, name: 'ReferralInvitePage', title: 'Invitation', segment: 'invite', allowAtWelcome: true },
    /**/ { component: ReferralHubPage, name: 'ReferralHubPage', title: 'Invite a Friend', segment: 'referral', parent: SettingsPage },
    // NOTE: IntakeFormPage is registered twice, under the SAME name, for its two
    // segments. getPageTitleByName() looks up by name and therefore always finds
    // this first entry, so the 'Intake Review' title below is unreachable through
    // it and only its segment is used for routing. That predates #4317 (find()
    // already returned the first match); the translated title map inherits it.
    /**/ { component: IntakeFormPage, name: 'IntakeFormPage', title: 'Intake', segment: 'intake-form' },
    /**/ { component: IntakeFormPage, name: 'IntakeFormPage', title: 'Intake Review', segment: 'intake-review' },
    /**/ { component: IntroCarouselPage, name: 'IntroCarouselPage', title: 'Intro Carousel', segment: 'intro-carousel' },
    /**/ { component: AwaitingCoachPage, name: 'AwaitingCoachPage', title: 'Awaiting Coach', segment: 'awaiting-coach' },
    /**/ { component: TestingRootPage, name: 'TestingRootPage', title: 'Testing Menu', segment: 'testing', parent: HomePage },
    /*  */ {
    component: TestWorkoutSolverPage,
    name: 'TestWorkoutSolverPage', title: 'Test Workout Solver',
    segment: 'test-workout-solver',
    parent: TestingRootPage,
  },
    /*  */ {
    component: TestNavigationRootPage,
    name: 'TestNavigationRootPage', title: 'Test Navigation Root',
    segment: 'test-navigation-root',
    parent: TestingRootPage,
  },
    /*    */ {
    component: TestNavigationChildPage,
    name: 'TestNavigationChildPage', title: 'Test Navigation Child',
    segment: 'test-navigation-child',
    parent: TestNavigationRootPage,
  },
    /*  */ {
    component: TestUiComponentsPage,
    name: 'TestUiComponentsPage', title: 'Test UI Components',
    segment: 'test-ui-components',
    parent: TestingRootPage,
  },
    /*    */ {
    component: TestUiToastsPage,
    name: 'TestUiToastsPage', title: 'Test UI Toasts',
    segment: 'test-ui-toasts',
    parent: TestUiComponentsPage,
  },
    /*    */ {
    component: TestUiNutrientsPage,
    name: 'TestUiNutrientsPage', title: 'Test UI Nutrients',
    segment: 'test-ui-nutrients',
    parent: TestUiComponentsPage,
  },
    /**/ { component: HelpCardPage, name: 'HelpCardPage', title: 'Help', segment: 'help-card-page', parent: HomePage, allowAtWelcome: true },
  { component: AdminImpersonatedUserPage, name: 'AdminImpersonatedUserPage', title: 'Admin Impersonate User', segment: 'admin-impersonated-user', parent: HomePage },
  { component: MealSuggestionsPage, name: 'MealSuggestionsPage', title: 'Meal Suggestions', segment: 'meal-suggestions', parent: HomePage },
  { component: NotePage, name: 'NotePage', title: 'Note', segment: 'note', parent: HomePage },
  { component: PurchaseSuccessPage, name: 'PurchaseSuccessPage', title: 'Subscription Active', segment: 'purchase-success', parent: HomePage },
  { component: NutritionInfoPage, name: 'NutritionInfoPage', title: 'Nutrition Info', segment: 'nutrition-info', parent: HomePage },
  { component: TaskCalendarPage, name: 'TaskCalendarPage', title: 'Task Calendar', segment: 'task-calendar', parent: HomePage },
  { component: InputCalendarPage, name: 'InputCalendarPage', title: 'Calendar', segment: 'input-calendar', parent: HomePage, allowAtWelcome: true },
  { component: ChangeWorkoutPage, name: 'ChangeWorkoutPage', title: 'Change Workout', segment: 'change-workout', parent: TrainingPage },
  { component: TrainingOverviewPage, name: 'TrainingOverviewPage', title: 'Training Overview', segment: 'training-overview', parent: TrainingPage },
  { component: SendFeedbackPage, name: 'SendFeedbackPage', title: 'Send Feedback', segment: 'send-feedback', parent: HomePage, allowAtWelcome: true },
  { component: SendCoachMessagePage, name: 'SendCoachMessagePage', title: 'Message Coach', segment: 'send-coach-message', parent: SettingsPage },
  { component: HelpPage, name: 'HelpPage', title: "Help & FAQ", segment: 'help', parent: HomePage, allowAtWelcome: true },
  { component: CliAuthPage, name: 'CliAuthPage', title: 'CLI Authorization', segment: 'cli-auth', allowAtWelcome: true },
  /**/ { component: CoachSettingsPage, name: 'CoachSettingsPage', title: 'Coaching', segment: 'coach-root', parent: SettingsPage, allowAtWelcome: true },
  /*  */ { component: CoachClientDetailPage, name: 'CoachClientDetailPage', title: 'Client Detail', segment: 'coach-client-detail', parent: CoachSettingsPage, allowAtWelcome: true },
  /*  */ { component: CoachBillingPage, name: 'CoachBillingPage', title: 'Coach Billing', segment: 'coach-billing', parent: CoachSettingsPage, allowAtWelcome: true },
  /*  */ { component: CoachBrandingPage, name: 'CoachBrandingPage', title: 'Branding', segment: 'coach-branding', parent: CoachSettingsPage, allowAtWelcome: true },
  // Become a Coach is reached from the user's own profile, not from the Coaching
  // screen, so it is not indented under it.
  /**/ { component: CoachCheckoutPage, name: 'CoachCheckoutPage', title: 'Become a Coach', segment: 'coach-checkout', parent: UserProfilePage, allowAtWelcome: true },
  /**/ { component: CoachClaimPage, name: 'CoachClaimPage', title: 'Coach Claim', segment: 'coach-claim' },
];

export function initDeepLinks() {
  setAllDeepLinks(allDeepLinks);
}
